import { getMaintenanceSlots, getMaintenanceTimeSpans, saveMaintenanceSlots } from "@/lib/api/maintenance";
import { MaintenanceTimeSpan, ResourceMaintenanceSlot } from "@/lib/types/maintenance";
import { defineStore } from "pinia";

interface MaintenanceState {
    maintenances: ResourceMaintenanceSlot[];
    timespans: MaintenanceTimeSpan[];
    loading: boolean;
}

export const useMaintenancesStore = defineStore('maintenances', {
    state: (): MaintenanceState => ({
        maintenances: [],
        timespans: [],
        loading: false
    }),

    actions: {
        async fetchByResourceId(resourceId: string): Promise<void> {
            this.loading = true;

            try {
                const res = await getMaintenanceSlots(resourceId);
                const index = this.maintenances.findIndex(slot => slot.resourceId === resourceId);
                if (index !== -1) {
                    this.maintenances[index] = res;
                } else {
                    this.maintenances.push(res);
                }
            } catch (err) {
                console.error(err);
                throw err;
            } finally {
                this.loading = false;
            }
        },

        async fetchTimeSpans(from: string, to: string, resourceId?: string): Promise<void> {
            this.loading = true;

            try {
                const res = await getMaintenanceTimeSpans(from, to, resourceId);
                this.timespans = res;
            } catch (err) {
                console.error(err);
                throw err;
            } finally {
                this.loading = false;
            }
        },

        async setMaintenanceSlots(maintenanceSlots: ResourceMaintenanceSlot): Promise<ErrorMessage | void> {
            try {
                const res = await saveMaintenanceSlots(maintenanceSlots);

                if (res && 'errorCode' in res) {
                    return res
                }
            } catch (err) {
                console.error(err);
                throw err;
            } finally {
                this.loading = false;
            }
        }
    },
    getters: {
        getSlotsByResourceId: (state) => {
            return (resourceId: string): ResourceMaintenanceSlot | undefined => {
                return state.maintenances.find(slot => slot.resourceId === resourceId);
            }
        }
    }
})